export { default as StyledChip } from './StyledChip';
